<aig-modal class="aig-modal-mail" position="center" customMaxWidth="600px">
  <div class="u-p-8 u-pb-3" body>
    <div class="p-flexcc u-dir-col">
      <img src="./assets/images/logos/logo.svg" class="u-mb-3" />
      <p class="u-fs-20 u-fw-400 u-color-black u-mt-def">
        ¿Has olvidado tu contraseña?
      </p>
      <p class="u-fs-18 u-fw-400 u-color-black u-mt-def">Introduce la dirección de correo electrónico asociada a tu
        cuenta y te enviaremos un enlace para restablecer la contraseña.</p>
    </div>
    <form class="row" [formGroup]="mailForm">
      <div class="col-12 u-mt-7">
        <div class="e-field">
          <label for="mail-field" class="e-field__label">
            Email
          </label>
          <input type="email" class="e-field__input u-ps-2 u-py-1" id="usuario-field" formControlName="mail"
            autocomplete="off" />
        </div>
      </div>
    </form>

  </div>
  <div class="p-flexcc u-m-7 u-mt-0 u-gap-16" buttons>
    <button class="aig-insertMail__btn e-btn--secondary" (click)="clickHide()">
      Cancelar
    </button>
    <button class="aig-insertMail__btn e-btn--primary p-flexcc" [disabled]="mailForm.invalid" (click)="onSubmitResetPassword()" >
      Enviar
    </button>
  </div>
</aig-modal>
